/**
 * CarIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const CarIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M6.5 15.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m13-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0" />
    <path
      fillRule="evenodd"
      d="M21 8h-.28l-1.09-3.27A4 4 0 0 0 15.84 2H8.16a4 4 0 0 0-3.79 2.74L3.28 8H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2v1a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-1h8v1a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-1a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2M6.26 5.37A2 2 0 0 1 8.16 4h7.68a2 2 0 0 1 1.9 1.37L18.61 8H5.39zM6 20H5v-1h1zm13 0h-1v-1h1zM3 17v-7h18v7z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const CarIcon = makeIcon('CarIcon', CarIconSvg)
